import {
  faPencil, faPencilSlash, faUserShield,
} from '@fortawesome/pro-solid-svg-icons';
import type { DropdownOption } from '~/_shared/baseComponents/dropdown';
import { EntityAccessLevel } from '~/_shared/entityAccess/entityAccess.repository';
import type { TranslationFnc } from '~/_shared/utils/hooks';
import { TeamShareMapPermission } from './teamShareMap.types';

export const getTeamShareMapPermissionOptions = (
  t: TranslationFnc,
  includeOwner?: boolean,
): DropdownOption<TeamShareMapPermission>[] => [
  ...includeOwner ? [{
    icon: faUserShield,
    name: t('Owner'),
    value: TeamShareMapPermission.Owner,
  }] : [],
  {
    icon: faPencil,
    name: t('Editor'),
    value: TeamShareMapPermission.Contributor,
  },
  {
    icon: faPencilSlash,
    name: t('View Only'),
    value: TeamShareMapPermission.ViewOnly,
  },
];

export const teamShareMapPermissionToEntityAccessLevel = (tsmp: TeamShareMapPermission) => {
  if (tsmp === TeamShareMapPermission.Owner || tsmp === TeamShareMapPermission.Contributor) {
    return EntityAccessLevel.WRITE;
  }
  return EntityAccessLevel.READ;
};

export const entityAccessLevelToTeamShareMapPermission = (entityAccessLevel: EntityAccessLevel) => {
  if (entityAccessLevel === EntityAccessLevel.WRITE) {
    return TeamShareMapPermission.Contributor;
  }
  return TeamShareMapPermission.ViewOnly;
};

export const entityAccessLevelToTeamShareMapPermissionTranslation = (
  entityAccessLevel: EntityAccessLevel,
  t: TranslationFnc,
): string => {
  const teamShareMapPermission = entityAccessLevelToTeamShareMapPermission(entityAccessLevel);
  const permissionOption = getTeamShareMapPermissionOptions(t).find(
    (option) => option.value === teamShareMapPermission,
  );
  if (permissionOption) {
    return permissionOption.name;
  }
  return t('Unknown');
};
